import {
  IconButton,
  Snackbar as PaperSnackbar,
  Text,
} from 'react-native-paper';
import { useAppSelector, useAppDispatch } from '../redux/hooks';
import { closeSnackbar } from '../redux/snackbarSlice';
import { useAppTheme } from '../theme';
import { View } from 'react-native';

export default function Snackbar() {
  const theme = useAppTheme();
  const dispatch = useAppDispatch();
  const { isOpen, message, severity } = useAppSelector(
    (state) => state.snackbar
  );

  function getBackgroundColor() {
    let color = theme.colors.snackbarError;
    if (severity === 'success') {
      color = '#2DBD09';
    }
    return color;
  }

  return (
    <PaperSnackbar
      visible={isOpen}
      duration={3000}
      onDismiss={() => {
        dispatch(closeSnackbar());
      }}
      style={{
        backgroundColor: getBackgroundColor(),
        justifyContent: 'center',
        maxHeight: 60,
        minWidth: 350,
        maxWidth: 500,
        alignItems: 'center',
      }}
      wrapperStyle={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <View
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        {severity === 'error' ? (
          <IconButton icon="alert-circle" iconColor="white" />
        ) : (
          <IconButton icon="check" iconColor="white" />
        )}
        <Text style={{ color: 'white', fontSize: 16 }}>{message}</Text>
      </View>
    </PaperSnackbar>
  );
}
